/**
 * メディアクエリー
 *
 * @export
 * @returns
 */
export function isDevice() {
  const MEDIA_QUERY = window.matchMedia('(max-width: 1023px)');
  if (MEDIA_QUERY.matches) {
    return 'sp';
  } else {
    return 'pc';
  }
}

/**
 * 0埋め
 *
 * @export
 * @param {number} value
 * @param {number} len
 * @returns
 */
export function zeroPadding(value, len) {
  if (Number.isNaN(value - 0)) {
    return value;
  }
  return (Array(len).join('0') + value).slice(-len);
}

/**
 * ハンドルの名前を取得する
 *
 * @export
 * @param {number} gradeFirstLetter
 * @returns
 */
export function getHandleName(grade) {
  if (!grade) return;
  // アルピーヌコードに紐づいた処理
  const gradeFirstLetter = grade.charAt(0)
  if (
    gradeFirstLetter === "J" ||
    gradeFirstLetter === "G"
  ) {
    return '標準（右）';
  } else {
    return '左';
  }
}

/**
 *
 * 数値のコードとエンドアイテム種別からサムネイルのURLを返却する
 * @export
 * @param {string} code
 * @param {string} identifier
 * @returns
 */
export function getThumbUrl(code, identifier, carType) {
  if (typeof code !== 'string') {
    return code;
  }
  if (
    identifier === 'interior' ||
    identifier === 'wheel' ||
    identifier === 'caliper'
  ) {
    return `./assets/img/enditem/${identifier}/${carType}/${code}.jpg`;
  } else {
    return `./assets/img/enditem/${identifier}/${code}.jpg`;
  }
}
